import React, { useCallback, useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Button, Card, Container, Row, Col, Table, Form } from "react-bootstrap";

import { useDropzone } from "react-dropzone";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { getDetailEntete, saveFileAvoir, getDetailRetour } from "../../Redux/reclamationReduce";
import jwt_decode from "jwt-decode";
import { t } from "react-multi-lang";
import Configuration from "../../configuration";
import Swal from 'sweetalert2';
import ImprimerAvoirReclamation from "./ImprimerAvoirReclamation";

function DetailsAvoirReclamation({ obj, client }) {
  const dispatch = useDispatch();
  const location = useParams();
  const idReclamation = location.id;
  const token = localStorage.getItem("x-access-token");
  const decoded = jwt_decode(token);
  const isSubmitting = useRef(false);
  const [reclamation, setReclamation] = useState({});
  const [loaderbtn, setLoaderbtn] = React.useState(false);
  const [avoir, setAvoir] = useState([]);
  const [loader, setLoader] = useState(true);
  const [files, setFiles] = useState([]); // <-- plusieurs fichiers

  const handleFileChange = (index, file) => {
    const newAvoir = [...avoir];
    newAvoir[index].file = file;
    setAvoir(newAvoir);
  };

  /* detailRetourn */
  const detailRetour = useCallback(
    async (idReclamation) => {
      setLoader(true);
      console.log("ici")
      try {
        const dataReclamation = await dispatch(
          getDetailRetour({
            idReclamation,
            id_site: client == "/medis" ? 2 : 3,
          })
        );

        const payload = dataReclamation.payload;
        console.log(payload.details_retours)
        const array = [];
        if (payload?.details_retours && Array.isArray(payload.details_retours)) {
          payload.details_retours.forEach((element) => {
            array.push({
              Numero_avoir: element.Numero_avoir,
              Numero_retour_plateforme: element.Numero_retour_plateforme,
              Numero_retour_sage: element.Numero_retour_sage,
            });
          });
        }

        console.log("Liste des numéros de retour:", array);
        setAvoir(array)
        setLoader(false);
      } catch (err) {
        console.error("Erreur lors du chargement des détails de retour:", err);
        setLoader(false);
      }
    },
    [dispatch, client]
  );

  const detailAvoirReclamation = useCallback(
    async (idReclamation) => {
      setLoader(true);

      try {
        const dataReclamation = await dispatch(
          getDetailEntete({
            idReclamation,
            id_site: client == "/medis" ? 2 : 3,
          })
        );
        const payload = dataReclamation.payload;
        setReclamation(payload);
        setLoader(false);
      } catch (err) {
        console.error("Erreur lors du chargement des détails de retour:", err);
        setLoader(false);
      }
    },
    [dispatch, client]
  );

  useEffect(() => {
    detailAvoirReclamation(idReclamation);
    if (obj.user.id_role === 11 || obj.user.id_role === 10) detailRetour(idReclamation);
  }, [idReclamation, detailRetour]);



  const handleUpload = async () => {
    try {
      if (isSubmitting.current) return;
      console.log(client)
      let continuerSave = 0;
      const resultSwal = await Swal.fire({
        title: 'Voulez-vous envoyer le mail maintenant ou simplement enregistrer sans envoi ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non',
      });

      if (resultSwal.isConfirmed) {
        continuerSave = 1;
      }
      setLoaderbtn(true);
      isSubmitting.current = true;
      const formData = new FormData();
      formData.append("idReclamation", idReclamation);
      formData.append("client", client);
      formData.append("envoie", continuerSave);

      formData.append("id_site", client == "/medis" ? 2 : 3);
      avoir.forEach((f, index) => {
        formData.append(`avoirs`, f.file);
        formData.append(`Numero_avoir[${index}]`, f.Numero_avoir);
        formData.append(`Numero_retour_plateforme[${index}]`, f.Numero_retour_plateforme);
        formData.append(`Numero_retour_sage[${index}]`, f.Numero_retour_sage);

      });

      const result = await dispatch(saveFileAvoir(formData));

      if (result.payload && result.payload.fichiers) {
        toast.success("Fichiers enregistrés avec succès !");
        detailAvoirReclamation(idReclamation);
        setFiles([]); // reset sélection
        setLoaderbtn(false);
        isSubmitting.current = false;
      } else {
        toast.error("Impossible de récupérer les fichiers enregistrés.");

        setLoaderbtn(false);
        isSubmitting.current = false;
      }
    } catch (error) {
      toast.error("Erreur lors de l'enregistrement des fichiers.");
      setLoaderbtn(false);
      isSubmitting.current = false;
    }
  };

  return (
    <>
      {loader ? (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      ) : (
        <Container fluid>
          <ToastContainer />
          <Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={() => window.history.back()}
              >
                <span className="btn-label">
                  <i className="fas fa-list"></i>
                </span>
                {t("list")}
              </Button>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                  <Card.Title as="h4">{"Détail avoir"}</Card.Title>
                </Card.Header>
                <Card.Body>
                  {reclamation.envoie == 1 ? (
                    reclamation.avoirs && reclamation.avoirs.length > 0 && (
                      <div>
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-info">
                              <th>Numéro Retour plateforme</th>
                              <th>Code Grossiste</th>
                              <th>Grossiste</th>
                              <th>Recap</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{reclamation.numero}</td>
                              <td>{reclamation?.grossistes.Code_client}</td>
                              <td>{reclamation?.grossistes.Raison_sociale}</td>
                              <td>{reclamation.traiter == 2 && reclamation.type_reclamation == 1 ?
                                <ImprimerAvoirReclamation t={t} idReclamation={idReclamation} type={2} />
                                : null}</td>
                            </tr>
                          </tbody>
                        </table>
                        <hr></hr>
                        {reclamation.avoirs.map((f, idx) => (
                          <>
                            <h3><strong>{f.Numero_avoir}</strong></h3>
                            <iframe
                              key={idx}
                              src={`${Configuration.BACK_BASEURL}avoir/${f.file_avoir}`}
                              width="100%"
                              height="600px"
                              style={{ border: "none", marginBottom: "20px" }}
                              title={`PDF Viewer ${idx + 1}`}
                            ></iframe></>
                        ))}

                      </div>

                    )
                  ) : null}

                  {((obj.user.id_role === 11 || obj.user.id_role === 10) && (reclamation.envoie == 0 && reclamation.avoirs.length > 0)) ? (
                    reclamation.avoirs && reclamation.avoirs.length > 0 && (
                      <div>
                        <table className="table table-bordered">
                          <thead>
                            <tr className="table-info">
                              <th>Numéro Retour plateforme</th>
                              <th>Code Grossiste</th>
                              <th>Grossiste</th>
                              <th>Recap</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{reclamation.numero}</td>
                              <td>{reclamation?.grossistes.Code_client}</td>
                              <td>{reclamation?.grossistes.Raison_sociale}</td>
                              <td>{reclamation.traiter == 2 && reclamation.type_reclamation == 1 ?
                                <ImprimerAvoirReclamation t={t} idReclamation={idReclamation} type={2} />
                                : null}</td>
                            </tr>
                          </tbody>
                        </table>
                        <hr></hr>
                        {reclamation.avoirs.map((f, idx) => (
                          <>
                            <h3><strong>{f.Numero_avoir}</strong></h3>
                            <iframe
                              key={idx}
                              src={`${Configuration.BACK_BASEURL}avoir/${f.file_avoir}`}
                              width="100%"
                              height="600px"
                              style={{ border: "none", marginBottom: "20px" }}
                              title={`PDF Viewer ${idx + 1}`}
                            ></iframe></>
                        ))}
                    
                      </div>
                    )
                  ) : (obj.user.id_role != 11 && obj.user.id_role != 10 && reclamation.envoie == 0) ? (
                    <p>Aucun Avoir disponible.</p>
                  ) : null}


                  {((obj.user.id_role === 11 || obj.user.id_role === 10) && (reclamation.envoie == 0 && reclamation.avoirs.length == 0)) ? (
                    <Col md="12">
                      <h5><strong>Retours et Avoirs</strong></h5>
                      <Table striped bordered hover responsive>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Numéro retour plateforme</th>
                            <th>Numéro avoir</th>
                            <th>Numéro retour Sage</th>
                            <th>Fichier PDF</th>
                          </tr>
                        </thead>
                        <tbody>
                          {avoir?.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.Numero_retour_plateforme}</td>
                              <td>{item.Numero_avoir}</td>
                              <td>{item.Numero_retour_sage}</td>
                              <td>
                                <Form.Control
                                  type="file"
                                  accept="application/pdf"
                                  onChange={(e) => handleFileChange(index, e.target.files[0])}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                    </Col>
                  ) : null}


                  {reclamation?.envoie == 0 && (obj.user.id_role === 11 || obj.user.id_role === 10) && (
                    !loaderbtn ? (
                      <Button
                        className="btn-fill pull-right"
                        type="button"
                        variant="info"
                        onClick={handleUpload}
                      >
                        {t("save")}
                      </Button>
                    ) : (
                      <div className="pull-right text-info font-weight-bold">
                        ⏳ Enregistrement en cours...
                      </div>
                    )
                  )}

                  <div className="clearfix"></div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </>
  );
}

export default DetailsAvoirReclamation;
